export function processMenuOptions(item, _) {
	if (item.data) item.data = item.data.map(i => processMenuOptions(i, _));
	return {
		...item,
		text: _(item.text),
		css: item.disabled ? "disabled" : "",
	};
}
